export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">移动阅读</h2>
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              歪歪漫画网全面适配移动端浏览器，无需下载APP即可在手机上享受流畅的下拉式全集阅读体验。随时随地，畅快追更好看的日漫韩漫国漫大全。
            </p>

            <ul className="space-y-3 mb-8 max-w-md mx-auto lg:mx-0">
              {[
                '打开手机浏览器，输入歪歪漫画网站入口即可访问',
                '自适应移动端屏幕，纵向滑动即可下拉式阅读',
                '支持添加到手机桌面，一键直达阅读入口',
                '节省存储空间，无需下载安装任何应用',
              ].map((text, i) => (
                <li key={i} className="flex items-start gap-3 text-background-50/90 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-background-50/20 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-background-50"></i>
                  </span>
                  {text}
                </li>
              ))}
            </ul>

            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-accent-500 font-semibold rounded-md hover:bg-background-100 transition-colors whitespace-nowrap text-sm cursor-pointer"
            >
              <i className="ri-smartphone-line text-lg"></i>
              立即开始阅读
            </a>
          </div>

          <div className="flex-1 w-full max-w-sm">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20manga%20webtoon%20in%20vertical%20scroll%20format%2C%20warm%20orange%20accent%20colors%2C%20modern%20mobile%20UI%20mockup%2C%20clean%20white%20phone%20frame%2C%20cozy%20background%2C%20digital%20reading%20experience%2C%20flat%20illustration%20style&width=600&height=900&seq=app-manga-01&orientation=portrait"
              alt="歪歪漫画移动端阅读体验"
              className="w-full h-auto rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}